import PrivateImage from '../presentation/PrivateImage';
import React, {useEffect, useRef, useState} from "react";
import {Redirect, useParams} from "react-router-dom";
import UserService from "../../services/user.service";
import '../../Print.css';
import { logOut} from "../../helpers/logout";
import {Button, Divider, Grid, Toolbar} from "@material-ui/core";
import ActionButton from "../form/input/ActionButton";
import Tooltip from "@material-ui/core/Tooltip";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import GeneratedDocumentEmailAction from "./GeneratedDocumentEmailAction";
import {PDFExport} from '@progress/kendo-react-pdf';
import {getPdfExportProxyProps, savePdfWithEmbeddedImages} from "../../helpers/pdfExport";
import {NotificationManager} from "react-notifications";
import TextInput from "../form/input/TextInput";
import DateInput from "../form/input/DateInput";
import Time from "react-time-format";

const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    seeMore: {
        marginTop: theme.spacing(8),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    toolbarButtons: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(1)
        }
    },
    marginElement: {
        margin: theme.spacing(2)
    },
    marginTop: {
        marginTop: theme.spacing(2)
    },
    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
        marginTop: theme.spacing(4),
    },
    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    cardMedia: {
        height: 200,
        width: 150,
        borderRadius: 10
    },
    cardContent: {
        flexGrow: 1,
    },
}));


const ConfirmationGenerator = (props) => {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper);

    const pdfRef = useRef(null);
    const [funeral, setFuneral] = useState({
        contracting_authority: '',
        ca_address: '',
        ca_zip: '',
        ca_city: '',
        ca_state: '',
        ca_nationality: '',
        ca_email: '',
        ca_phone: '',
        ca_id: '',
        ca_birth: '',
        ca_relationship: '',
        deceased: '',
        d_address: '',
        d_zip: '',
        d_city: '',
        d_state: '',
        d_place_birth: '',
        d_birth: '',
        d_gender: '',
        d_marital_status: '',
        d_death: '',
        d_place_death: '',
        d_id: '',
        d_nationality: '',
        d_education: '',
        d_last_job: '',
        d_wife_husband: '',
        d_wife_husband_id: '',
        planned_pickup_place: '',
        planned_pickup: '',
        town_funeral: '',
        place_funeral: '',
        date_funeral: '',
        coffin_arrival: '',
        coffin_arrival_place: '',
        signatures: {}
    });
    const [success, setSuccess] = useState(false);
    const [date, setDate] = useState(new Date());
    const [location, setLocation] = useState('');

    const [user, setUser] = useState(null);

    const funeral_id = useParams();
    const user_local = JSON.parse(localStorage.getItem('user')).id;

    const handleDate = (e) => {
        setDate(e.target.value)
    }

    const handleLocation = (e) => {
        setLocation(e.target.value)
    }

    useEffect(() => {
        UserService.getUser(user_local).then(
            (response) => {
                setUser(response.data);
                if (response.data.defined_texts) {
                    setLocation(response.data.defined_texts.default_signature_place);
                }
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
        UserService.getFuneral(funeral_id.funeral_id).then(
            (response) => {
                setFuneral(response.data);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
    }, [funeral_id.funeral_id, user_local, props]);

    const handleExport = () => {
        savePdfWithEmbeddedImages(pdfRef);
    }

    const showDelegation = () => {
        if (user) {
            return <div className="document-preview-frame" style={{border: '1px solid'}}>
                <PDFExport ref={pdfRef} {...getPdfExportProxyProps()} paperSize="A4" scale={0.75}
                           fileName={`potvrdenie-${funeral.contracting_authority.replace(' ', '')}`}>
                    <div className="a4-paper gendoc-doc gendoc-doc--dense">
                        {user.logo &&
                        <div className="gendoc-watermark-wrap">
                            <PrivateImage className="gendoc-watermark" src={user.logo} alt=""/>
                        </div>}
                        <div className="gendoc-body">
                            <header className="gendoc-header">
                                <div className="gendoc-header__eyebrow">{user.name}</div>
                                <h1 className="gendoc-title">Potvrdenie do zamestnania</h1>
                                <div className="gendoc-header__meta">
                                    {user.address} · IČO: {user.ico} · IČ DPH: {user.ic_dph} · Kontakt: {user.phone} · Email: {user.email_official}
                                </div>
                            </header>

                            <div className="gendoc-legal">
                                <p>
                                    Pohrebná služba <strong>{user.name}</strong> potvrdzuje, že menovaný <strong>{funeral.contracting_authority}</strong> bytom <strong>{funeral.ca_address} {funeral.ca_city} {funeral.ca_zip}</strong> v príbuzenskom vzťahu <strong>{funeral.ca_relationship}</strong> dňa {funeral.signatures.date_of_remains ? new Date(funeral.signatures.date_of_remains).toShortFormat() : date.toShortFormat()} <strong>OBSTARÁVAL/A</strong> pohreb nebohého <strong>{funeral.deceased}</strong>, ktorý zomrel dňa <strong><Time value={funeral.d_death} format="DD.MM.YYYY"/></strong> a pohreb mal <strong><Time value={funeral.date_funeral} format="DD.MM.YYYY"/></strong> v <strong>{funeral.place_funeral}, {funeral.town_funeral}</strong>.
                                </p>
                                <p><strong>Potvrdenie sa vydáva pre potreby zamestnávateľa.</strong></p>
                            </div>

                            <div className="gendoc-sign gendoc-sign--single">
                                <div className="gendoc-sign__col gendoc-sign__col--right">
                                    <div className="gendoc-sign__meta">
                                        V {funeral.signatures.location_of_remains ? funeral.signatures.location_of_remains : location} dňa {funeral.signatures.date_of_remains ? new Date(funeral.signatures.date_of_remains).toShortFormat() : date.toShortFormat()}.
                                    </div>
                                    {user.stamp && <PrivateImage className="gendoc-sign__stamp" src={user.stamp} alt="Pečiatka"/>}
                                </div>
                            </div>

                            <div className="gendoc-legal gendoc-legal--fine">
                                Manžel/manželka alebo dieťa: 2 dni pri úmrtí a ďalší deň na účasť na pohrebe (spolu 3 dni). Rodič alebo súrodenec
                                zamestnanca, rodič alebo súrodenec jeho manžela/manželky, manžel/manželka súrodenca zamestnanca: 1 deň na účasť
                                na pohrebe a ďalší deň, ak zamestnanec obstaráva pohreb (spolu 2 dni). Prarodič alebo vnuk zamestnanca, prarodič
                                manžela/manželky, alebo iná osoba, ktorá žila so zamestnancom v spoločnej domácnosti: 1 deň na účasť na pohrebe a
                                ďalší deň, ak zamestnanec obstaráva pohreb (spolu najviac 2 dni).
                            </div>

                            <hr className="gendoc-cut"/>

                            <header className="gendoc-header">
                                <div className="gendoc-header__eyebrow">{user.name}</div>
                                <h1 className="gendoc-title">Potvrdenie do zamestnania</h1>
                                <div className="gendoc-header__meta">
                                    {user.address} · IČO: {user.ico} · IČ DPH: {user.ic_dph} · Kontakt: {user.phone} · Email: {user.email_official}
                                </div>
                            </header>

                            <div className="gendoc-legal">
                                <p>
                                    Pohrebná služba <strong>{user.name}</strong> potvrdzuje, že menovaný <strong>{funeral.contracting_authority}</strong> bytom <strong>{funeral.ca_address} {funeral.ca_city} {funeral.ca_zip}</strong> v príbuzenskom vzťahu <strong>{funeral.ca_relationship}</strong> dňa {funeral.signatures.date_of_remains ? new Date(funeral.signatures.date_of_remains).toShortFormat() : date.toShortFormat()} <strong>OBSTARÁVAL/A</strong> pohreb nebohého <strong>{funeral.deceased}</strong>, ktorý zomrel dňa <strong><Time value={funeral.d_death} format="DD.MM.YYYY"/></strong> a pohreb mal <strong><Time value={funeral.date_funeral} format="DD.MM.YYYY"/></strong> v <strong>{funeral.place_funeral}, {funeral.town_funeral}</strong>.
                                </p>
                                <p><strong>Potvrdenie sa vydáva pre potreby zamestnávateľa.</strong></p>
                            </div>

                            <div className="gendoc-sign gendoc-sign--single">
                                <div className="gendoc-sign__col gendoc-sign__col--right">
                                    <div className="gendoc-sign__meta">
                                        V {funeral.signatures.location_of_remains ? funeral.signatures.location_of_remains : location} dňa {funeral.signatures.date_of_remains ? new Date(funeral.signatures.date_of_remains).toShortFormat() : date.toShortFormat()}.
                                    </div>
                                    {user.stamp && <PrivateImage className="gendoc-sign__stamp" src={user.stamp} alt="Pečiatka"/>}
                                </div>
                            </div>

                            <div className="gendoc-legal gendoc-legal--fine">
                                Manžel/manželka alebo dieťa: 2 dni pri úmrtí a ďalší deň na účasť na pohrebe (spolu 3 dni). Rodič alebo súrodenec
                                zamestnanca, rodič alebo súrodenec jeho manžela/manželky, manžel/manželka súrodenca zamestnanca: 1 deň na účasť
                                na pohrebe a ďalší deň, ak zamestnanec obstaráva pohreb (spolu 2 dni). Prarodič alebo vnuk zamestnanca, prarodič
                                manžela/manželky, alebo iná osoba, ktorá žila so zamestnancom v spoločnej domácnosti: 1 deň na účasť na pohrebe a
                                ďalší deň, ak zamestnanec obstaráva pohreb (spolu najviac 2 dni).
                            </div>
                        </div>
                    </div>
                </PDFExport>
            </div>
        }
        return <></>
    }

    return (
        <Container maxWidth="lg" className={classes.seeMore}>
            <div className={classes.root}>
                <Paper className={fixedHeightPaper}>
                    <Grid container>
                        <Grid xs={12} sm={4} md={3} lg={3} item container>
                            <Toolbar>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    hidden={true}
                                    className={classes.button}
                                    onClick={() => {
                                        setSuccess(true)
                                    }}
                                >
                                    Späť na detaily
                                </Button>
                            </Toolbar>
                        </Grid>
                        <Grid xs={12} sm={8} md={9} lg={9} item container justifyContent='flex-end'>
                            <Toolbar className={`${classes.toolbarButtons} document-actions-toolbar`}>
                                <TextInput
                                    label="Miesto podpisu"
                                    name={'location'}
                                    value={location}
                                    onChange={handleLocation}
                                />
                                <DateInput
                                    label="Dátum podpisu"
                                    name={'date'}
                                    value={date}
                                    onChange={handleDate}
                                />
                                <ActionButton
                                    color="primary">
                                    <Tooltip title="Pdf export">
                                        <PictureAsPdfIcon
                                            fontSize="small"
                                            onClick={handleExport}
                                        />
                                    </Tooltip>
                                </ActionButton>
                                <GeneratedDocumentEmailAction
                                    pdfRef={pdfRef}
                                    funeral={funeral}
                                    user={user}
                                />
                            </Toolbar>
                        </Grid>
                    </Grid>

                    <Divider/>
                    <Grid className={classes.marginTop}
                          container
                          spacing={0}
                          direction="column"
                          alignItems="center"
                          justifyContent="center"
                    >
                        {showDelegation()}
                    </Grid>
                </Paper>
            </div>
            {success ? <Redirect to={{
                pathname: `/pohreb/${funeral_id.funeral_id}/info`,
                state: {from: props.location, number: 5}
            }}/> : <></>}
        </Container>
    )
}
export default ConfirmationGenerator;

